import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import { ApiAptitudeTestChoiceResponse } from 'src/services/entity-factory/factories/AptitudeTestChoiceFactory';
import FilledAptitudeTestQuestion from 'src/entities/FilledAptitudeTestQuestion';

export interface ApiFilledAptitudeTestQuestionResponse {
  questionId: number;
  choice: ApiAptitudeTestChoiceResponse;
}

interface ApiFilledAptitudeTestQuestionCreateRequest {
}

export class FilledAptitudeTestQuestionFactory extends BaseFactory<FilledAptitudeTestQuestion> {
  public toEntity(args: ApiFilledAptitudeTestQuestionResponse): FilledAptitudeTestQuestion {
    return new FilledAptitudeTestQuestion({
      questionId: args.questionId,
      choice: args.choice ? this.entityFactoryFactory.aptitudeTestChoiceFactory.toEntity(args.choice) : undefined,
    });
  }

  public toRequest(filledAptitudeTestQuestion: FilledAptitudeTestQuestion): ApiFilledAptitudeTestQuestionCreateRequest {
    return filledAptitudeTestQuestion;
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/FilledAptitudeTestQuestionFactory.tsx